<p-dialog
  [closable]="false"
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '75vw' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body">
  <ng-template pTemplate="header">
    <div class="w-100 has-border">
      <h2>Copy Lines 2</h2>
    </div>
  </ng-template>
  <div class="dialog-section mb-4">
    <!-- <h3>Copy Header</h3> -->
    <!-- <p-table
      #dt
      [value]="samplePOHeader"
      [(selection)]="selectedSamplePOHeader"
      selectionMode="multiple"
      styleClass="p-datatable-customers ordersLineItems no-wrap"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th
            class="col-center"
            style="width: 3rem"
            (click)="getLineAgainstHeader()"
          >
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th>Purchase Order Number</th>
          <th>Vendor Name</th>
          <th>Job Name</th>
          <th>Customer Name</th>
          <th>BC Name</th>
          <th>Status</th>
          <th>Created By</th>
          <th>Created Date</th>
          <th>Project ID</th>
        </tr>
        <tr>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="purchaseOrderNumber"
                id="purchaseOrderNumber"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'purchaseOrderNumber',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component"
              />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="vendorName"
                id="vendorName"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'vendorName',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component"
              />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="jobName"
                id="jobName"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'jobName', 'startsWith')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component"
              />
            </div>
          </th>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="bcName"
                id="bcName"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'bcName', 'startsWith')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component"
              />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="status"
                id="status"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'status', 'startsWith')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component"
              />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-samplePOHeader let-rowIndex="rowIndex">
        <tr class="p-selectable-row" (click)="getLineAgainstHeader()">
          <td class="col-center">
            <p-tableCheckbox [value]="samplePOHeader"></p-tableCheckbox>
          </td>
          <td>
            <span class="p-column-title">Purchase Order Number</span>
            {{ samplePOHeader.purchaseOrderNumber }}
          </td>
          <td>
            <span class="p-column-title">Vendor Account Number</span>
            <a>{{ samplePOHeader.vendorName }}</a>
          </td>
          <td>
            <span class="p-column-title">Job Name</span>
            {{ samplePOHeader.jobName }}
          </td>
          <td>
            <span class="p-column-title">Customer Name</span>
            {{ samplePOHeader.customerName }}
          </td>
          <td>
            <span class="p-column-title">BC Name</span>
            {{ samplePOHeader.bcName }}
          </td>
          <td>
            <span class="p-column-title">Status</span>
            {{ samplePOHeader.status }}
          </td>
          <td>
            <span class="p-column-title">Created By</span>
            {{ samplePOHeader.createdBy }}
          </td>
          <td>
            <span class="p-column-title">Created Date</span>
            {{ samplePOHeader.createdDate | date: 'MM-dd-yyyy' }}
          </td>
          <td>
            <span class="p-column-title">Project ID</span>
            {{ samplePOHeader.projectId }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No sample po header found.</td>
        </tr>
      </ng-template>
    </p-table> -->

    <p-table
      #dt
      stripedRows
      responsiveLayout="scroll"
      [value]="samplePOListings"
      [(selection)]="selectedSamplePO"
      styleClass="p-datatable-customers search-more"
      [rowHover]="true"
      [rows]="25"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      scrollHeight="calc(100vh - 500px)"
      [size]="'small'"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 50, 1000]"
      [paginator]="false"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [filterDelay]="0"
      [paginator]="true"
      [rows]="defaultTake"
      [lazy]="true"
      (onLazyLoad)="getAllSamplepoListingData($event)"
      [totalRecords]="totalRecords"
      [globalFilterFields]="[]"
      styleClass="table-listing">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th></th>
          <th>Purchase Order Number</th>
          <th>Vendor Name</th>
          <th>Job Name</th>
          <th>Client Name</th>
          <th>BC Name</th>
          <th>Status</th>
          <th>Created By</th>
          <th>Created Date</th>
          <th>Project ID</th>
        </tr>
        <tr>
          <th></th>
          <th>
            <div class="d-flex">
              <p-columnFilter
                type="text"
                field="purchaseOrderNumber"
                (input)="onFilterInput($event)"
                [showMenu]="false"></p-columnFilter>
            </div>
          </th>
          <th>
            <div class="d-flex">
              <p-columnFilter
                type="text"
                field="vendorName"
                (input)="onFilterInput($event)"
                [showMenu]="false"></p-columnFilter>
            </div>
          </th>
          <th>
            <div class="d-flex">
              <p-columnFilter
                type="text"
                field="jobName"
                [showMenu]="false"
                (input)="onFilterInput($event)"></p-columnFilter>
            </div>
          </th>
          <th></th>
          <th>
            <div class="d-flex">
              <p-columnFilter
                type="text"
                field="bcName"
                [showMenu]="false"
                (input)="onFilterInput($event)"></p-columnFilter>
            </div>
          </th>
          <th>
            <div class="d-flex">
              <p-columnFilter
                type="text"
                field="status"
                [showMenu]="false"
                (input)="onFilterInput($event)"></p-columnFilter>
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-samplePOListing let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pSelectableRow]="samplePOListing"
          [pSelectableRowIndex]="rowIndex">
          <td class="col-center">
            <p-tableCheckbox
              #e
              [disabled]="false"
              [value]="samplePOListing"
              [pSelectableRow]="samplePOListing"
              (click)="
                selectRow(
                  e.checked ?? false,
                  samplePOListing.purchaseOrderNumber
                )
              "></p-tableCheckbox>
          </td>
          <td (click)="getCurrentSamplePo(samplePOListing.purchaseOrderNumber)">
            <!-- <span class="p-column-title">Purchase Order Number</span> -->
            <ng-container
              *ngIf="
                !samplePOListing?.purchaseOrderNumber
                  ?.toLowerCase()
                  ?.includes('temp')
              ">
              <a class="link-underline">
                {{ samplePOListing.purchaseOrderNumber }}
              </a>
            </ng-container>
          </td>
          <td>
            <!-- <span class="p-column-title">Vendor Account Number</span> -->
            <a>{{ samplePOListing.vendorName }}</a>
          </td>
          <td>
            <!-- <span class="p-column-title">Job Name</span> -->
            {{ samplePOListing.jobName }}
          </td>
          <td>
            <!-- <span class="p-column-title">Client Name</span> -->
            {{ samplePOListing.customerName }}
          </td>
          <td>
            <!-- <span class="p-column-title">BC Name</span> -->
            {{ samplePOListing.bcName }}
          </td>
          <td>
            <!-- <span class="p-column-title">Status</span> -->
            {{ samplePOListing.status }}
          </td>
          <td>
            <!-- <span class="p-column-title">Created By</span> -->
            {{ samplePOListing.createdBy }}
          </td>
          <td>
            <!-- <span class="p-column-title">Created Date</span> -->
            <span *ngIf="samplePOListing?.createdDate | hidedynamicsdate">
              {{ samplePOListing.createdDate | date: "MM-dd-yyyy" }}
            </span>
          </td>
          <td>
            <!-- <span class="p-column-title">Project ID</span> -->
            {{ samplePOListing.projectId }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No sample po found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="dialog-section mb-4">
    <h3>Line items</h3>
    <p-table
      #dt
      stripedRows
      [rowHover]="true"
      [rows]="25"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      scrollHeight="calc(100vh - 310px)"
      [size]="'small'"
      [value]="samplePOLine"
      [(selection)]="selectedSamplePOLine"
      selectionMode="multiple"
      styleClass="p-datatable-customers ordersLineItems no-wrap"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="true"
      [filterDelay]="0"
      [rowHover]="true"
      dataKey="id"
      styleClass="table-listing">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th class="col-center" style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th class="number" pSortableColumn="number">#</th>
          <th class="vsku">Vendor SKU</th>
          <th class="dfield">Description</th>
          <th class="category">Category</th>
          <th class="sip-date">Ship date</th>
          <th class="inh-dates">In-hands dates</th>
          <th class="firm">Firm</th>
          <th class="quantity">Quantity</th>
          <th class="namount">Net amount</th>
          <th class="ntotal">NET TOTAL</th>
          <th class="fnotes">Factory Notes</th>
          <th class="fnotes"></th>
        </tr>
        <tr>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="lineNumberD365"
                id="lineNumberD365"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'lineNumberD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-samplePOLine let-rowIndex="rowIndex">
        <ng-container>
          <tr class="p-selectable-row">
            <td class="col-center">
              <p-tableCheckbox [value]="samplePOLine"></p-tableCheckbox>
            </td>
            <td class="number">
              <span class="link">{{ samplePOLine.lineNumberD365 }}</span>
            </td>
            <td class="notes">
              <span class="me-1">{{
                samplePOLine.externalItemNumberD365
              }}</span>
              <i class="icon-Notes icon"></i>
            </td>
            <td class="attachment">
              <span class="me-1">{{ samplePOLine.lineDescriptionD365 }}</span>
              <i class="icon-Attachment icon"></i>
            </td>
            <td class="vendor-sku">
              {{ samplePOLine.itemNumberD365 }}
            </td>
            <td>
              {{ samplePOLine.requestedShippingDateD365 | date: "MM-dd-yyyy" }}
            </td>
            <td>
              {{ samplePOLine.requestedDeliveryDateD365 | date: "MM-dd-yyyy" }}
            </td>
            <td class="description">
              {{ samplePOLine.rsmFirmD365 }}
            </td>
            <td class="unmatched">
              {{ samplePOLine.orderedPurchaseQuantityD365 }}
            </td>
            <td class="quantity">
              {{ samplePOLine.purchasePriceD365 }}
            </td>
            <td class="sell">
              {{ samplePOLine.lineAmountD365 }}
            </td>
            <td class="sell-total">
              {{ samplePOLine.factoryNotes }}
            </td>
          </tr>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No line item found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template class="pt-3" pTemplate="footer">
    <!-- <button class="btn btn-secondary" (click)="closeDialog()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="saveLines()"
      [disabled]="!selectedSamplePOLine.length">
      Save
    </button> -->
    <div class="d-flex gap-3 mt-3">
      <p-button
        label="Cancel"
        (click)="closeDialog()"
        variant="outlined"
        severity="secondary" />

      <p-button
        label="Save"
        (click)="saveLines()"
        [disabled]="!selectedSamplePOLine.length" />
    </div>
  </ng-template>
</p-dialog>
